import React from "react";
import { HashLoader } from "react-spinners";

const LoadingSpinner = ({
  show = true,
  text = "",
  fullPage = false,
  overlay = false,
  size = 60,
  color = "#1171ef",
  speedMultiplier = 1,
}) => {
  if (!show) return null;

  const Loader = (
    <div className="d-flex flex-column align-items-center justify-content-center text-center">
      <HashLoader
        loading
        size={size}
        color={color}
        speedMultiplier={speedMultiplier}
      />

      {text && (
        <div className="mt-3 text-muted" style={{ fontSize: 14 }}>
          {text}
        </div>
      )}
    </div>
  );

  // Full page
  if (fullPage) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        {Loader}
      </div>
    );
  }

  // Overlay
  if (overlay) {
    return (
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(255,255,255,0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          borderRadius: 8,
        }}
      >
        {Loader}
      </div>
    );
  }

  // Inline / area
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: 240 }}
    >
      {Loader}
    </div>
  );
};

export default LoadingSpinner;
